import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen grid place-items-center px-5 pt-20">
      <div className="glass-chroma rounded-3xl p-10 md:p-14 text-center max-w-lg" data-testid="payment-cancel">
        <XCircle className="text-[#ffe600] mx-auto mb-6" size={64} />
        <h1 className="font-display text-5xl uppercase">Payment Cancelled</h1>
        <p className="text-white/70 font-head mt-4">No charge was made. Your spot in the multiverse is still waiting — come back anytime.</p>
        <Link to="/get-involved" className="inline-block mt-8 bg-[#ff0055] text-white font-head font-bold uppercase px-8 py-3 rounded-full glow-magenta hover:scale-105 transition-transform" data-testid="cancel-retry-btn">Try Again</Link>
      </div>
    </div>
  );
}
